import { Box, Button, ButtonGroup } from "@mui/material";
import { forwardRef } from "react";
import { useRouteError, Link as RouterLink, } from "react-router-dom";
const LinkBehavior = forwardRef((props, ref) => (
  <RouterLink ref={ref} to="/" {...props} role={undefined} />
));
const LinkBehaviorLogin = forwardRef((props, ref) => (
  <RouterLink ref={ref} to="login" {...props} role={undefined} />
));
export default function NotFoundPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <Box sx={{ textAlign: 'center', }}>

      <Box sx={{ backgroundColor: '#66aaee', padding: 1 }}>
      </Box>
      <h1>Oops!</h1>
      Pagina non trovata 
      <p>
        <ButtonGroup>

        <Button variant="outlined" component={LinkBehavior}>ritorna all'homepage</Button>
        <Button variant="outlined" component={LinkBehaviorLogin}>vai al LOGIN</Button>
        </ButtonGroup>
      </p>
    </Box>
  );
}